import React from 'react';
import { siteContent } from '@/content/site';

const Footer: React.FC = () => {
    return (
        <footer className="compact-footer">
            <p>&copy; {new Date().getFullYear()} {siteContent.brand.name} | {siteContent.location}. {siteContent.rights}</p>
        </footer>
    );
};

export default Footer;
